// document.addEventListener("DOMContentLoaded", () => {
//   const dataEl = document.getElementById("quick-cart-variant-galleries");
//   if (!dataEl) return;

//   const galleries = JSON.parse(dataEl.textContent || "{}");

//   const swapImages = () => {
//     document.querySelectorAll(".quick-cart__item").forEach((itemEl) => {
//       const variantId = itemEl.dataset.id;
//       const gallery = galleries[variantId];

//       if (!gallery || !gallery.length) return;

//       const firstImg = gallery[0];
//       const src = firstImg.src || firstImg;

//       const imgEl = itemEl.querySelector(".quick-cart__image img");
//       if (!imgEl) return;

//       imgEl.dataset.src = `${src}&width=240`;
//       imgEl.src = `${src}&width=240`; // immediate swap
//     });
//   };

//   // initial load
//   swapImages();

//   // cart updates dynamically, so watch it
//   const cartContainer = document.querySelector("[data-items]");
//   if (!cartContainer) return;

//   new MutationObserver(swapImages).observe(cartContainer, {
//     childList: true,
//     subtree: true,
//   });
// });


document.addEventListener("DOMContentLoaded", () => {
  const SECTION_ID = "quick-cart-variant-galleries"; // section file name
  const SCRIPT_ID = "quick-cart-variant-galleries";  // script tag id
  const ITEMS_CONTAINER_SELECTOR = "[data-items]";

  let galleries = {};

  const safeJsonParse = (txt) => {
    try { return JSON.parse(txt || "{}") || {}; } catch { return {}; }
  };

  const readGalleriesFromDom = () => {
    const el = document.getElementById(SCRIPT_ID);
    return el ? safeJsonParse(el.textContent) : {};
  };

  const normalizeImageUrl = (url, width = 240) => {
    if (!url) return null;

    // metafield may return:
    // - "//cdn.shopify.com/..."
    // - "https://cdn.shopify.com/..."
    // - an object with src/url
    // - already has ?v=...&width=...
    const hasQuery = url.includes("?");
    const joiner = hasQuery ? "&" : "?";

    // avoid double width params if already present
    if (/[?&]width=\d+/i.test(url)) return url;

    return `${url}${joiner}width=${width}`;
  };

  const pickFirstGalleryUrl = (gallery) => {
    if (!gallery || !gallery.length) return null;
    const first = gallery[0];
    if (!first) return null;

    // common shapes: string OR {src:""} OR {url:""}
    return typeof first === "string" ? first : (first.src || first.url || null);
  };

  const applyImageSwap = (itemEl) => {
    const variantId = itemEl.getAttribute("data-id");
    if (!variantId) return;

    const gallery = galleries[String(variantId)];
    const raw = pickFirstGalleryUrl(gallery);
    const finalSrc = normalizeImageUrl(raw, 240);
    if (!finalSrc) return;

    const img = itemEl.querySelector(".quick-cart__image img");
    if (!img) return;

    // prevent infinite loops (mutation observer) by skipping if already correct
    if (img.getAttribute("src") === finalSrc && img.getAttribute("data-src") === finalSrc) return;

    // set everything the theme/lazyloader might use
    img.setAttribute("src", finalSrc);
    img.setAttribute("data-src", finalSrc);

    // wipe srcset variants if present (often causes old image to return)
    img.removeAttribute("srcset");
    img.removeAttribute("data-srcset");

    // many lazyload libs look at these classes; removing helps stop overrides
    img.classList.remove("lazyload");
    img.classList.remove("lazyloading");
    img.classList.add("lazyloaded");
  };

  const swapAllQuickCartImages = () => {
    // run after current DOM paint (theme just re-rendered)
    requestAnimationFrame(() => {
      document.querySelectorAll(".quick-cart__item[data-id]").forEach(applyImageSwap);
    });
  };

  const refreshGalleriesFromServer = async () => {
    // Use Section Rendering API: returns JSON like { "section-id": "<html...>" }
    const url = `${window.location.pathname}?sections=${encodeURIComponent(SECTION_ID)}`;

    const res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) return;

    const json = await res.json();
    const html = json && json[SECTION_ID];
    if (!html) return;

    const doc = new DOMParser().parseFromString(html, "text/html");
    const incoming = doc.getElementById(SCRIPT_ID);
    if (!incoming) return;

    // Update live script tag so future reads reflect newest cart
    const current = document.getElementById(SCRIPT_ID);
    if (current) current.textContent = incoming.textContent;

    galleries = readGalleriesFromDom();
  };

  // Debounce because cart renders can cause many mutations
  const debounce = (fn, wait = 120) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  };

  const handleCartRerender = debounce(async () => {
    // 1) fetch fresh JSON (Liquid evaluated on server with current cart)
    await refreshGalleriesFromServer();

    // 2) swap images using fresh JSON
    swapAllQuickCartImages();
  }, 120);

  // Initial
  galleries = readGalleriesFromDom();
  swapAllQuickCartImages();

  // Observe quick cart items container for dynamic rerenders
  const container = document.querySelector(ITEMS_CONTAINER_SELECTOR);
  if (!container) return;

  const observer = new MutationObserver(() => {
    handleCartRerender();
  });

  observer.observe(container, { childList: true, subtree: true });
});
